// Puzzle configuration and constants
export const PUZZLE_TYPES = {
  PATTERN: 'pattern',
  BINARY: 'binary'
};

export const DIFFICULTY_LEVELS = {
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard'
};

// Probability configs
export const PUZZLE_TRIGGER_CHANCE = {
  BASE: 0.35, // 35% base chance
  RANK_MULTIPLIER: 0.05, // 5% increase per rank
  QUBIT_BONUS: 0.002 // 0.2% per 100 qubits
};

// Puzzle generation settings
export const PUZZLE_CONFIG = {
  [PUZZLE_TYPES.PATTERN]: {
    gridSizes: {
      [DIFFICULTY_LEVELS.EASY]: 3,
      [DIFFICULTY_LEVELS.MEDIUM]: 4,
      [DIFFICULTY_LEVELS.HARD]: 5
    },
    symbols: ['0', '1'],
    [DIFFICULTY_LEVELS.EASY]: { rotations: 1, time: 45 },
    [DIFFICULTY_LEVELS.MEDIUM]: { rotations: 2, time: 30 },
    [DIFFICULTY_LEVELS.HARD]: { rotations: 3, time: 20 }
  },
  [PUZZLE_TYPES.BINARY]: {
    gridSize: 4, // Always 4x4
    time: 120, // 2 minutes
    // Rules for binary puzzles:
    // 1. Each cell must contain either 0 or 1
    // 2. No more than two similar numbers adjacent to each other
    // 3. Each row and column must contain an equal number of 0s and 1s
    // 4. Each row and column must be unique
    minPrefilledCells: 0.4, // 40% of cells prefilled for better solvability
    type: PUZZLE_TYPES.BINARY // Ensure type is set
  }
};

// Rewards for completing puzzles
export const PUZZLE_REWARDS = {
  [DIFFICULTY_LEVELS.EASY]: {
    qubits: 50,
    multiplier: 1.2
  },
  [DIFFICULTY_LEVELS.MEDIUM]: {
    qubits: 100,
    multiplier: 1.5
  },
  [DIFFICULTY_LEVELS.HARD]: {
    qubits: 200,
    multiplier: 2.0
  }
};